import React from 'react';
import { Plus } from 'lucide-react';
import { Button } from '../../../ui/Button';
import { LinkedInIcon } from '../../../ui/LinkedInIcon';

interface LinkedInEmptyStateProps {
  onConnect?: () => void;
}

/**
 * Empty state shown when no LinkedIn accounts are connected
 */
export const LinkedInEmptyState: React.FC<LinkedInEmptyStateProps> = ({ onConnect }) => (
  <div className="border-2 border-dashed border-neutral-200 rounded-xl p-8 text-center bg-neutral-50/50">
    <div className="w-12 h-12 rounded-xl bg-linkedin flex items-center justify-center mx-auto mb-3">
      <LinkedInIcon size={24} className="text-white" />
    </div>
    <h4 className="text-sm font-semibold text-neutral-900 mb-1">
      No LinkedIn Connected
    </h4>
    <p className="text-xs text-neutral-500 mb-4">
      Connect your LinkedIn account to send connection requests and messages.
    </p>
    {onConnect && (
      <Button
        id="connect-linkedin-empty"
        variant="primary"
        size="sm"
        onClick={onConnect}
        leftIcon={<Plus className="w-3.5 h-3.5" />}
        className="bg-linkedin hover:bg-linkedin-hover"
      >
        Connect LinkedIn
      </Button>
    )}
  </div>
);
